module.exports = __webpack_public_path__ + "img/dots.6288ce8a.svg";